import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

export const AdminAccountDialog = ({ currentEmail }) => {
  const [open, setOpen] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (newPassword && newPassword !== confirmPassword) {
      toast.error("Kata laluan baru tidak sepadan");
      return;
    }
    setSaving(true);
    try {
      const { data } = await api.put("/admin/account", {
        current_password: currentPassword,
        new_email: newEmail || null,
        new_password: newPassword || null,
      });
      if (data.access_token) localStorage.setItem("dirbiz_token", data.access_token);
      toast.success(
        data.password_changed ? "Kata laluan & akaun dikemas kini" : `Emel ditukar ke ${data.email}`
      );
      setOpen(false);
      setCurrentPassword("");
      setNewEmail("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" data-testid="admin-account-open">
          <KeyRound className="mr-1.5 h-4 w-4" /> Akaun
        </Button>
      </DialogTrigger>
      <DialogContent data-testid="admin-account-dialog" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight">Tukar emel / kata laluan</DialogTitle>
          <DialogDescription>
            Akaun semasa: <strong>{currentEmail}</strong>. Kata laluan semasa diperlukan untuk setiap
            perubahan.
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={submit} className="grid gap-5">
          <div>
            <Label htmlFor="acc-current">Kata laluan semasa *</Label>
            <Input
              id="acc-current"
              type="password"
              data-testid="admin-account-current-password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              className="mt-2 h-11"
              required
            />
          </div>
          <div>
            <Label htmlFor="acc-email">Emel baru (biar kosong jika tidak berubah)</Label>
            <Input
              id="acc-email"
              type="email"
              data-testid="admin-account-new-email"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
              placeholder={currentEmail}
              className="mt-2 h-11"
            />
          </div>
          <div>
            <Label htmlFor="acc-password">Kata laluan baru (min 8 aksara)</Label>
            <Input
              id="acc-password"
              type="password"
              data-testid="admin-account-new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="mt-2 h-11"
            />
          </div>
          {newPassword && (
            <div>
              <Label htmlFor="acc-confirm">Ulang kata laluan baru</Label>
              <Input
                id="acc-confirm"
                type="password"
                data-testid="admin-account-confirm-password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="mt-2 h-11"
              />
            </div>
          )}
          <Button
            type="submit"
            data-testid="admin-account-submit"
            disabled={saving || !currentPassword || (!newEmail && !newPassword)}
            className="h-11"
          >
            {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Simpan perubahan
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
